import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import React, { createContext, useContext, useState } from 'react';
var Context = createContext();
export var Provider = function Provider(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(props),
    _useState2 = _slicedToArray(_useState, 2),
    defaultProps = _useState2[0],
    setDefaultProps = _useState2[1];
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: {
      defaultProps: defaultProps
    }
  }, children);
};
export var useDefaults = function useDefaults(props) {
  var context = useContext(Context);
  if ('undefined' === typeof context) {
    return props;
  } else {
    return _objectSpread(_objectSpread({}, context.defaultProps), props);
  }
};